Core.Router = Backbone.Router.extend({
    routes: {

        'map': 'map',
        'messages': 'messages',
        'schedule': 'schedule',
        'calendar': 'calendar',
        'schedule-old': 'scheduleOld',
        'csat' : 'csat',

        'dashboard': 'dashboard',
        'staffledger*subroute': 'staffledger',
        'attest*subroute': 'attest',
        'reservations*subroute': 'reservations',
        'routes*subroute': 'rroutes',
        'projects*subroute': 'projects',
        'orders*subroute': 'orders',
        'jobs*subroute': 'jobs',
        'reports*subroute': 'reports',
        'assets*subroute': 'assets',
        'customers*subroute': 'customers',
        'users*subroute': 'users',
        'articles*subroute': 'articles',
        'invoicing*subroute': 'invoicing',
        'packinglist*subroute': 'packinglist',
        'group*subroute': 'group',
        'forms*subroute': 'forms',
        'shared*subroute': 'shared',
        'things*subroute': 'things',
        'billing*subroute': 'billing',
        'connect/scaniafmp-new': 'connectScaniaFMPNew',
		'connect/CSATResults': 'connectCSATResults',
        'connect*subroute': 'connect',
        'timebank*subroute': 'timebank',
        'reseller*subroute': 'reseller',
        'contracts*subroute': 'contracts',
        'sales': 'sales',
        'templates': 'templates',
        'places*subroute': 'places',
        'labels': 'labels',
        'phrases': 'phrases',
        'activities': 'activities',
        'documentcategories': 'documentcategories',
        'createaccounts': 'createaccounts',
        'createcustomeruseraccounts/:id': 'createcustomeruseraccounts',
        'sendschedule': 'sendschedule',
        'calendarexport': 'calendarexport',
        'import*subroute': 'import',
        'payrolls*subroute' : 'payrolls',
        'remotesignature*subroute': 'remotesignature',
        'transportdocuments*subroute': 'transportdocuments',

        '': 'home',
        'login': 'login',
        'logout': 'logout',
        'resetpassword': 'resetpassword',
        'changepassword': 'changepassword',
        'invitations': 'invitations',
        'invitations/:token': 'invitationToken',
        'signup/contract/:token': 'signupContract',
        'signup/invitation/:token': 'signupInvitation',
        'signup': 'signup',
        'setup': 'setup',
        'confirmemail/:token': 'confirmemail',
        'eula': 'eula',
        'microsoftInfo': 'microsoftInfo',
        'api': 'api',
        'api/all': 'apiAll',
        'api/usage': 'apiUsage',
        'api/:key/log': 'apiLog',
        'help': 'help',
        'changes': 'changes',
        'changesold': 'changesOld',
        'emailpreferences/:token': 'emailpreferences',
        'systemmessages': 'systemMessages',
        'x': 'error',
        'error': 'error',
        '*fallback': 'fallback'
    },

    unauthenticatedRoutes: [
        'login',
        'resetpassword',
        'signup',
        'signupContract',
        'signupInvitation',
        'confirmemail',
        'eula',
        'microsoftInfo',
        'shared',
        'emailpreferences',
        'changes',
        'changesold',
        'connectScaniaFMPNew',
    ],

    optionallyAuthenticatedRoutes: [
        'contracts',
        'viewContract',
    ],

    map: function () {
        var view = new CoreMap.MainMapView({el: $('#body-content')});
        app.setMainView(view, 'map');
    },

    messages: function () {
        app.setMainView(new MessagesView(), 'messages');
    },

    schedule: function() {
        app.setMainView(new ScheduleView2(), 'schedule');
    },

    scheduleOld: function () {
        app.setMainView(new ScheduleView(), 'schedule-old');
    },

    calendar: function () {
        app.setMainView(new CalendarView(), 'calendar');
    },

    dashboard: function () {
        debug.log('dashboard');
        app.setMainView(new DashboardView(), 'dashboard');
    },

    resellerDashboard: function () {
        app.setMainView(new ResellerCustomerListView());
    },

    payrolls: function(){ this.subRouter('payrolls', Core.PayrollsRouter)},

    staffledger: function() { this.subRouter('staffledger', Core.StaffLedgerRouter) },
    attest: function() { this.subRouter('attest', Core.AttestRouter) },
    reservations: function() { this.subRouter('reservations', Core.ReservationsRouter) },
    rroutes: function() { this.subRouter('routes', Core.RoutesRouter) },
    projects: function() { this.subRouter('projects', Core.ProjectsRouter) },
    orders: function() { this.subRouter('orders', Core.OrdersRouter) },
    jobs: function() { this.subRouter('jobs', Core.JobsRouter) },
    reports: function() { this.subRouter('reports', Core.ReportsRouter) },
    assets: function() { this.subRouter('assets', Core.AssetsRouter) },
    places: function() { this.subRouter('places', Core.PlacesRouter) },     // added by elias 20190321
    customers: function() { this.subRouter('customers', Core.CustomersRouter) },
    users: function() { this.subRouter('users', Core.UsersRouter) },
    articles: function() { this.subRouter('articles', Core.ArticlesRouter) },
    invoicing: function() { this.subRouter('invoicing', Core.InvoicingRouter) },
    packinglist: function () { this.subRouter('packinglist', Core.PackinglistRouter) },
    group: function () { this.subRouter('group', Core.GroupRouter) },
    forms: function () { this.subRouter('forms', Core.FormsRouter) },
    shared: function () { this.subRouter('shared', Core.SharedRouter) },
    things: function () { this.subRouter('things', Things.Router) },
    billing: function () { this.subRouter('billing', Billing.Router) },
    connectScaniaFMPNew: function() { this.subRouter('connect', Connect.Router) },
	connectCSATResults: function() { this.subRouter('connect', Connect.Router) },
    connect: function () { this.subRouter('connect', Connect.Router) },
    timebank: function() { this.subRouter('timebank',Core.TimebankRouter)},
    reseller: function () { this.subRouter('reseller', Core.ResellerRouter) },
    contracts: function() { this.subRouter('contracts', Core.ContractsRouter) },
    sales: function () { this.subRouter('sales', Core.SalesRouter) },
    import: function() { this.subRouter('import', Core.ImportRouter) },
    remotesignature: function() { this.subRouter('remotesignature', Core.RemoteSignatureRouter)},
    transportdocuments: function() { this.subRouter('transportdocuments', Core.TransportDocumentsRouter)},

    subRouter: function(name, subRouterClass) {
        if (!(name in this.sub)) this.sub[name] = new subRouterClass(name);
    },

    templates: function () {
        debug.log('templates');
        app.setMainView(new TemplatesView(), 'directory');
    },

    labels: function () {
        debug.log('labels');
        app.setMainView(new LabelsListView({collection: Core.client.labels}), 'directory');
    },

    phrases: function () {
        debug.log('phrases');
        app.setMainView(new PhrasesView({collection: Core.client.phrases}), 'directory');
    },

    activities: function () {
        debug.log('activities');
        app.setMainView(new ActivitiesView({collection: Core.client.activities}), 'directory');
    },

    documentcategories: function () {
        debug.log('document categories');
        app.setMainView(new DocumentCategoriesView(), 'directory');
    },

    createaccounts: function () {
        debug.log('create accounts');
        app.setMainView(new CreateAccountsView({
            // defaultExtensionService: '#{configurationCacheBean.parameterValue("newuser_extensions")'
        }), 'directory');
    },

    createcustomeruseraccounts: function (id) {
        debug.log('create customer user accounts');
        var view = new CreateCustomerAccountsView({
            // defaultExtensionService: '#{configurationCacheBean.parameterValue("newuser_extensions")'
        });
        view.customerId = id;
        console.log('customerId', view.customerId);
        app.setMainView(view, 'directory');
    },

    sendschedule: function () {
        debug.log('send schedule');
        var view = new SchedulePreviewView();
        app.setMainView(view);
    },

    calendarexport: function () {
        debug.log('export calendar');
        var view = new CalendarExportView();
        app.setMainView(view, 'calendar');
    },

    home: function () {
        debug.log('home');
        if (Core.client.primaryGroup() && Core.client.primaryGroup().get('reseller')) {
            this.resellerDashboard();
        } else {
            this.dashboard();
        }
    },

    login: function () {
        app.login();
    },

    logout: function () {
        app.logout();
        app.reloginAllTabs();
        if (location.search.indexOf('api_token') >= 0) {
            location.href = '/';
        } else {
            this.login();
        }
        if (location.search.indexOf('api_token') < 0) history.back();
    },

    resetpassword: function () {
        app.setMainView(new ResetPasswordView());
    },

    changepassword: function () {
        var view = app.setMainView(new ChangePasswordView());
        app.listenToOnce(view, 'done', function() {
            location.hash = '';
        });
    },

    invitations: function () {
        app.setMainView(new InvitationsView());
    },

    invitationToken: function(token) {
        app.setMainView(new InvitationsView({token: token}))
    },

    signup: function () {
        app.setMainView(new SignupView());
    },

    signupContract: function (token) {
        app.setMainView(new SignupView({contractToken: token}))
    },

    signupInvitation: function (token) {
        app.setMainView(new SignupView({invitationToken: token}))
    },

    setup: function () {
        app.setMainView(new SetupGuideView());
    },

    confirmemail: function (token) {
        app.setMainView(new EmailConfirmationView({token: token}));
    },

    eula: function () {
        if (Core.param().smartcraft_token) sessionStorage.login_credentials = JSON.stringify({"smartcraft_token" : Core.param().smartcraft_token});
        app.setMainView(new EndUserLicenseAgreementView());
    },

    microsoftInfo: function () {
        app.setMainView(new MicrosoftInfoView());
    },

    api: function () {
        app.setMainView(new ApiConsumersView(), 'settings');
    },

    apiAll: function () {
        app.setMainView(new ApiConsumersView({path: 'all'}), 'admin');
    },

    apiUsage: function () {
        app.setMainView(new ApiUsageView({}), 'admin');
    },

    apiLog: function (key) {
        app.setMainView(new ApiRequestLogView({key: key}));
    },

    help: function () {
        app.setMainView(new HelpView(), 'help');
    },

    changes: function () {
        app.setMainView(new ChangesView());
    },

    changesOld: function () {
        app.setMainView(new ChangesOldView());
    },

    emailpreferences: function (token) {
        app.setMainView(new EmailPreferencesView({token: token}));
    },

    csat: function() {
        app.setMainView(new CsatStatisticsView(), 'csat');
    },

    systemMessages: function () {
        if((Core.client.hasPermission('view_all_data') || Core.client.hasPermissionInAnyGroup('view_all_data')) && 
            Core.client.hasPermission('edit_all_data') || Core.client.hasPermissionInAnyGroup('edit_all_data')){
            app.setMainView(new SystemMessagesView(), 'systemMessages');
        }else{
            this.error()
        }
    },

    error: function(options) {
        app.setMainView(new ErrorView(options));
    },

    fallback: function () {
        if (Core.param('oldroute') && location.hash && location.hash.length > 1) {

            // Redirects from old web, keeping some important links intact

            var hash = location.hash.substring(1);
            var oldroute = Core.param('oldroute');
            var route = '';
            switch (oldroute) {
                case 'reservation': route = 'reservations/' + hash; break;
                case 'order': route = 'orders/' + hash; break;
                case 'job': route = 'jobs/' + hash; break;
                case 'route': route = 'routes/' + hash; break;
                case 'report': route = 'reports/' + hash; break;
                case 'invoice': route = 'invoicing/' + hash; break;
                case 'packinglist': route = 'packinglist/' + hash; break;
                case 'myaccount': route = 'users/me'; break;
                case 'billing': route = 'billing'; break;
                case 'setup': route = 'setup'; break;
                default:
                    debug.error('unknown oldroute: ' + oldroute);
            }
            this.navigate(route, { trigger: true, replace: true });

        } else {
            debug.error('fallback route: ' + this.name);
            this.home();
        }
    },

    execute: function (callback, args, name, context) {
        try {
            debug.log('route: ' + name);
            app.routeName = name;
            var self = this;
            if (!context) context = this;

            if (!app.loaded) {
                debug.log('not loaded for route');
                app.load(function () {
                    this.execute(callback, args, name);
                }, this);
                return false;
            }

            if (Core.param('login_user') || Core.param('login_pass')) {
                app.logout();
                app.reloginAllTabs();
            }

            // Store invitation token from parameter for later use by invitations view when login/signup is completed
            if (Core.param('invitationtoken')) {
                sessionStorage.invitationToken = Core.param('invitationtoken');
                debug.log('invitation token', sessionStorage.invitationToken);
            }
            if (Core.param('contracttoken')) {
                sessionStorage.contractToken = Core.param('contracttoken');
                debug.log('contract token', sessionStorage.contractToken);
            }

            if (!Core.apiToken && name != 'login' && this.unauthenticatedRoutes.indexOf(name) < 0) {
                var token = Core.param('access_token') || Core.param('api_token') || sessionStorage['core_apiToken'] || Core.param('t');
                if (token) {
                    if (!Core.client) Core.initialize();
                    Core.setupTokens(token);
                    debug.log('validate token before route');
                    Core.client.validateToken().success(function() {
                        debug.log('validate token success');
                        Core.client.initialize();
                        if (Core.param('api_token')) {
                            // Allow login with api_token etc parameters. These should work:
                            // http://localhost:8888/#jobs?api_key=ebd55df7e84a96df6b05c1c394c8ac5d&api_token=828d04db50236f54240864ecaa88deba&foo=bar
                            // http://localhost:8888?api_key=ebd55df7e84a96df6b05c1c394c8ac5d&api_token=828d04db50236f54240864ecaa88deba&foo=bar#jobs
                            var params = Core.param();
                            delete params.api_token;
                            delete params.api_key;
                            if (location.hash.indexOf('api_token') >= 0) {
                                location.hash = location.hash.substring(0, location.hash.indexOf('?'))
                                    + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
                            }
                        }
                        app.resumeSession(function () {
                            self.execute(callback, args, name);
                        });
                    }).error(function(response) {
                        debug.error('token validation failed', response);
                        app.removeSession(true);
                        if (Core.param('api_token')) {
                            location.href = '/#tokenloginfail';
                        } else {
                            app.reloginAllTabs();
                            app.login();
                        }
                    });
                    return false;
                } else if (this.optionallyAuthenticatedRoutes.indexOf(name) < 0) {
                    debug.log('not logged in for route ' + name);
                    app.login(function () {
                        this.execute(callback, args, name);
                    }, this);
                    return false;
                }
            }

            // Delay if we need to get basic info first (can be provoked by F5 reload),
            // to avoid view not having permissions loaded
            if (Core.apiToken && Core.client && Core.client.me && (!Core.client.me.loaded || !Core.client.groups.loaded || !Core.client.permissions.loaded)) {
                debug.log('no basic info for route');
                var retry = function() {
                    if (Core.client.me.loaded && Core.client.groups.loaded && Core.client.permissions.loaded) {
                        app.tick();
                        debug.log('re-route for basic info');
                        self.execute(callback, args, name);
                    }
                }
                this.listenToOnce(Core.client.me, 'load', retry);
                this.listenToOnce(Core.client.groups, 'load', retry);
                this.listenToOnce(Core.client.permissions, 'load', retry);

                if (this.rerouteTimeout) clearTimeout(this.rerouteTimeout);
                this.rerouteTimeout = setTimeout(function() {
                    debug.error('basic info timeout! apply route and fetch');
                    if (callback) callback.apply(context, args);
                    Core.client.me.fetch();
                    Core.client.groups.fetch();
                    Core.client.permissions.fetch();
                }, 3000);
                return false;
            }

            // Avoid route loops by delaying - could be caused by programming errors
            var timeSinceLastRoute = new Date().getTime() - (context.lastRoute || 0);
            if (timeSinceLastRoute < 300) {
                debug.error('delaying route - last route ' + timeSinceLastRoute + ' ms ago');
                if (this.delayTimeout) clearTimeout(this.delayTimeout);
                this.delayTimeout = setTimeout(function() {
                    debug.log('re-route after delay');
                    self.execute(callback, args, name);
                }, 500);
                return false;
            }
            context.lastRoute = new Date().getTime();
            debug.log('route proceed' + (callback ? '' : ' NO CALLBACK!?'));
            if (this.rerouteTimeout) clearTimeout(this.rerouteTimeout);
            if (callback) callback.apply(context, args);
        } catch (e) {
            this.error({
                type: 'route',
                title: i18next.t('routeErrorTitle'),
                description: i18next.t('routeErrorDescription'),
                details: e,
                trace: e.stack
            });
            throw e;
        }
    },

    initialize: function() {
        this.sub = {};
    },

});
